import { useEffect, useRef, useState } from "react";
import "../styles/header.css";
import { useLocation, useNavigate } from "react-router-dom";
import Clock from "../components/Clock";
import Tab from "../components/Tab";
import { memo } from "react";
import useIsMobile from "../hooks/useIsMobile";
import SearchChannel from "../components/SearchChannel";

const paths = ["/news", "/movies", "/sports", "/music"];

const Header = ({ scrollY }) => {
  const [selectedTab, setSelectedTab] = useState(null);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const headerRef = useRef();
  const isMobile = useIsMobile();

  useEffect(() => {
    scrollY >= 99
      ? headerRef.current.classList.add("is-sticky")
      : headerRef.current.classList.remove("is-sticky");
  }, [scrollY]);

  useEffect(() => {
    if ("/" === location.pathname || location.pathname.includes("/news")) {
      setSelectedTab("/");
    } else {
      const lastIndex = location.pathname.lastIndexOf("/");
      const tab =
        lastIndex > 0
          ? location.pathname.substring(0, location.pathname.lastIndexOf("/"))
          : location.pathname;
      setSelectedTab(tab);
    }
  }, []);

  useEffect(() => {
    if ("/" === location.pathname) {
      setSelectedTab("/");
      return;
    }
    const lastIndex = location.pathname.lastIndexOf("/");
    const tab =
      lastIndex > 0
        ? location.pathname.substring(0, location.pathname.lastIndexOf("/"))
        : location.pathname;
    if ("/news" === tab) {
      setSelectedTab("/");
      return;
    }
    const isValidTab = paths.includes(tab);
    setSelectedTab(isValidTab ? tab : "/extra");
  }, [location.pathname]);

  const getTabButtonClass = (id) => {
    return selectedTab === id ? "tab-button tab-button-selected" : "tab-button";
  };

  const onTabSelect = (id) => {
    setSelectedTab(id);
    navigate(id);
  };

  return (
    <>
      <header className="header" ref={headerRef}>
        <div className="logo-container">
          <div className="logo-item">
            <div class="logo" onClick={() => navigate("/")}>
              <span class="plex">PLEX</span>
              <span class="tv">TV</span>
            </div>
          </div>
        </div>
        <div className="tabs-group">
          <Tab
            getTabButtonClass={getTabButtonClass}
            onTabSelect={onTabSelect}
            selectedTab={selectedTab}
          />
          {!isMobile && (
            <span
              class="material-symbols-outlined"
              onClick={() => setOpen(true)}
            >
              search
            </span>
          )}
        </div>
        <div className="additional">
          {isMobile ? (
            <span
              class="material-symbols-outlined"
              onClick={() => setOpen(true)}
            >
              search
            </span>
          ) : (
            <Clock />
          )}
        </div>
      </header>
      {open && <SearchChannel open={open} setOpen={setOpen} />}
    </>
  );
};

export default memo(Header);
